import React from 'react';

const week = [6,0,1,2,3,4,5]

export const plural = (value, title) => {
  let array = title.split('/')
  let mTitle = array[0] + (((value === 0 || value > 1) && array[1] !== undefined )? array[1]: '')
  return mTitle
}

export const DatetoHtml = (date, result, langPlace) => {
  const month = langPlace.monthshort
  if (date === undefined){
    return (result)
  } else {
    const mDate = new Date(date)
    const y = mDate.getFullYear()
    const m = mDate.getMonth()
    const d = mDate.getDate()
    //const w = mDate.getDay()

    return ( `${d} ${month[m]} ${y}` )
  }
}

export const Prices = (value) =>{
  if (value !== undefined){
    return `${value.toLocaleString('es-ES',{minimumFractionDigits: 2})} €`
  } else {
    return '0,00€'
  }

}

export const DatetoHtml2 = (date, langPlace, result) => {
  const days = langPlace.daysname
  const month = langPlace.monthnames
  if (date === undefined){
    return (result)
  } else {
    const mDate = new Date(date)
    const y = mDate.getFullYear()
    const m = mDate.getMonth()
    const d = mDate.getDate()
    const w = mDate.getDay()

    return (
      <div>{days[week[w]]}, {d} {month[m]} {y}</div>
    )
  }
}

export const PassangersLine = (props, langPlace) => {
  const {nAdults, nTeens, nKids, nBabies, nPets} = props
  const array = [[langPlace.adults, nAdults], [langPlace.teens, nTeens], [langPlace.kids, nKids], [langPlace.babys, nBabies], [langPlace.pets, nPets]]
  let result = PropsLine(array, 2)
  return (result)
}

export const VehiclesLine = (props, langPlace) => {
  const {nAdults, nTeens, nKids, nBabies, nPets,
         nCars, nMotorcycles, nVans, nBikes, nTowing} = props
  const array = [[langPlace.cars, nCars], [langPlace.motorcycles, nMotorcycles], [langPlace.vans, nVans], [langPlace.bikes, nBikes], [langPlace.towings, nTowing]]
  const passangers = nAdults + nTeens + nKids + nBabies + nPets
  const vehicles = nCars + nMotorcycles + nVans + nBikes + nTowing
  if (passangers > 0) {
    if (vehicles > 0) {
      let result = PropsLine(array, 1)
      return (result)
    } else {
      return (langPlace.confirmnovehicles)
    }
  } else {
    return ('')
  }
}

const PropsLine = (array, max) => {
  let count = 0
  let result = ''
  array.forEach(function(val){
    if ( val[1] > 0 ){
      count++
      if (count <= max ){
        result += val[1] + ' ' + plural(val[1], val[0]) + ', '
      }
    }
  })

  result = result.substr(0, result.length - 2)
  if (count > max ){
    result += ' ...'
  }
  return (result)
}



// WEBPACK FOOTER //
// ./src/shared/routes/components/functions.js